<template>
  <zm-button
    type="primary"
    round
    size="large"
    :loading="isLoading"
    :disabled="disabled"
    @click="next"
    class="opc-btn-continue"
    :class="{
      'opc-modal': isModal
    }"
  >
    {{ $t('billing.continue') }}
  </zm-button>
</template>

<script>
import { routePathMap } from '@/router/constant';
import { mapGetters } from 'vuex';
import { showCouponTermsMessage } from '@/views/config/coupon/helper/utils';
import { getQueryByLocationSearch } from '@/utils/index';
import { mapProducts } from '@/aspects/trackings';
import { validAddonPlansWithBasePlan } from '@/common/service/validate';
import { preCheckForPbx } from '@/common/service/validate/pbx';
import { beforeCheckForCoupon } from '@/views/config/coupon/helper/validator';
import { checkCountriesRegionsOption } from '@/common/service/validate/tollfree';
import flow from '@/flows';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['tncMessage', 'getSelectedPlans', 'isSelectedSameAsEditablePlansInBought', 'fromCampaignLink']),
    disabled() {
      return (!this.getSelectedPlans?.length || this.isSelectedSameAsEditablePlansInBought) && !this.fromCampaignLink;
    },
  },
  methods: {
    async next() {
      try {
        this.isLoading = true;
        await flow.beforeContinue();
        await validAddonPlansWithBasePlan();
        await beforeCheckForCoupon();
        await showCouponTermsMessage(this.tncMessage);
        await preCheckForPbx()
        await checkCountriesRegionsOption();
        // TODO 1, validate and notifications, 2, use namespaced modules
        this.$store.commit('savePersist');
        if (this.isModal) {
          this.$emit('next')
        } else {
          this.$router.push({
          path: routePathMap.checkout,
          query: { usageType: getQueryByLocationSearch().usageType },
          });
        }
        this.$tracking(() => ({ event: 'Cart Add', products: mapProducts(this.getSelectedPlans) }));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';

.opc-btn-continue{
  width: 100%;
  background: $theme-color;
  &.opc-modal {
    @include media(desktop, tablet) {
      &.zm-button.zm-button--primary.zm-button--large.is-round {
        min-width: 100px;
        width: auto;
      }
      &.zm-button.is-round {
        border-radius: 10px;
      }
    }
  }
}
</style>
